{
  "account": {
    "changeEmail": "Change Email",
    "changePassword": "Change Password",
    "emailNotUnique": "Cannot confirm email. Email address is used with other accounts.",
    "accountDetails": "Account Details",
    "tabs": {
      "profile": "Profile",
      "email": "Email",
      "password": "Password",
      "mfa": "MFA"
    },
    "title": "Account",
    "subtitle": "Personal account management",
    "changeEmailNeedsConfirmation": "Changing your email address will require reconfirmation if you have MFA configured.",
    "emailStatus": "Email Status",
    "emailConfirmed": "Email confirmed:",
    "resendVerificationEmail": "Resend verification email",
    "mfaNeedsConfirmedEmail": "Multi Factor Authentication is enabled for your account. Login will not be possible until your email address is confirmed.",
    "newPasswordSameAsOld": "New password cannot be the same as the old password.",
    "recoveryCodesLeft": "Recovery Codes Left:",
    "mustGenerate": "You must {link} before you can log in with a recovery code.",
    "appNeedsConfirmedEmail": "You can register an authenticator app when your email address has been confirmed.",
    "configureApp": "Configure app",
    "configureAppHint": "Configure an authenticator app to issue MFA tokens for Airside Regulations.",
    "resetKeysHint": "Reset your authentication key and invalidate current app registrations.",
    "removeAppHint": "Remove authenticator app verification from your account.",
    "enableApp": "Enable Authenticator App",
    "enableSteps": "To use an authenticator app go through the following steps:",
    "enableStepDownload": "Download a two-factor authenticator app like Microsoft Authenticator, Google Authenticator or an app of your choice that supports TOTP. You can scan one of the QR codes below with your device to be directed to the App Store or Google Play.",
    "enableStepScan": "Scan the QR Code or enter this key {key} into your two factor authenticator app. Spaces and casing do not matter.",
    "enableStepVerify": "Once you have scanned the QR code or input the key above, your two factor authentication app will provide you with a unique code. Enter the code in the confirmation box below.",
    "newCodesKeepKeys": "Generating new recovery codes does not change the keys used in authenticator apps. If you wish to change the key used in an authenticator app you should {link}.",
    "resetKeysLink": "reset your authenticator keys",
    "removeAppTitle": "Remove Authenticator App",
    "removeAppFallback": "If you remove your authenticator app, Airside Regulations will fall back to email token verification.",
    "removeAppRecommendation": "We strongly recommend {app} to help secure your account.",
    "removeAppReEnable": "re-enabling a Two-Factor Authentication (2FA) app",
    "removeAppButton": "Remove authenticator app",
    "resetAppTitle": "Reset Authenticator App",
    "resetAppWarning": "If you reset your authenticator key your authenticator app will not work until you reconfigure it.",
    "resetAppLoseAccess": "If you do not complete your authenticator app configuration immediately you may lose access to your account.",
    "resetKeyButton": "Reset authenticator key",
    "codesUseOnce": "Each recovery code can only be used once. If you run out of recovery codes to use, you can reset them to create a new list of codes to use.",
    "codesSafePlace": "{safePlace} If you lose your device and don't have the recovery codes you will lose access to your account.",
    "codesSafePlaceStrong": "Put these codes in a safe place.",
    "codesShownOnce": "These codes are only displayed once and cannot be recalled once you navigate away from this page.",
    "signsInWithExternal": "You sign in with {provider}, which manages your password and MFA."
  },
  "checklist": {
    "dgPresent": "Are dangerous goods present?",
    "dgTagsPresent": "Are all tags present?",
    "dgStrapsCorrect": "Are straps correct?",
    "cargoNetsCorrect": "Are all nets correct?",
    "cargoRopesCorrect": "Are all ropes correct?",
    "cargoLocksCorrect": "Are all locks correct?",
    "cargoEquipmentInspected": "Is equipment visually inspected?",
    "stepDangerousGoods": "Dangerous Goods",
    "stepCargo": "Cargo & Equipment",
    "stepConfirmation": "Confirmation",
    "title": "Confirm Start Drive",
    "notCompliant": "This drive does not comply with safety regulations.",
    "correct": "Correct Checklist",
    "startOnResponsibility": "Start Drive (driver responsibility)",
    "driveTitle": "Drive Checklist",
    "none": "No checklist was filled in for this drive."
  },
  "common": {
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "no": "No",
    "notApplicable": "N/A",
    "unitCount": "{n} Unit | {n} Units",
    "yes": "Yes",
    "addEntity": "Add {entity}",
    "details": "{entity} Details",
    "pleaseConfirm": "Please Confirm",
    "readOnly": "Read Only",
    "save": "Save",
    "edit": "Edit",
    "editEntity": "Edit {entity}",
    "noOptions": "No Options",
    "options": "Options",
    "saveAndEdit": "Save & Edit",
    "next": "Next",
    "previous": "Previous",
    "copy": "Copy",
    "copied": "Copied!"
  },
  "confirmDelete": {
    "title": "Delete {entity}",
    "question": "Are you sure you want to delete this item?",
    "irreversible": "This action is irreversible and can only be executed when the item is not in use!"
  },
  "connection": {
    "connected": "Connected",
    "connecting": "Connecting",
    "reconnecting": "Reconnecting",
    "disconnecting": "Disconnecting",
    "disconnected": "Disconnected",
    "failed": "Connection failed, you will not receive data updates.",
    "reconnect": "Try to reconnect."
  },
  "driveStatus": {
    "unassigned": "Unassigned",
    "pending": "Pending",
    "started": "Started",
    "completed": "Completed",
    "cancelled": "Cancelled"
  },
  "drivers": {
    "title": "Drives",
    "showUnits": "Show Units",
    "complete": "Complete",
    "finished": "Finished",
    "startDrive": "Start Drive",
    "selectUnits": "Select units",
    "selectUnitsHint": "Select units to assign to this drive.",
    "startDriveWith": "Start Drive with {n} unit | Start Drive with {n} units",
    "mail": "Mail:",
    "shc": "SHC:"
  },
  "entities": {
    "carrier": "Carrier",
    "category": "Category",
    "customer": "Customer",
    "location": "Location",
    "sla": "SLA",
    "station": "Station",
    "user": "User",
    "awb": "AWB",
    "drive": "Drive",
    "transport": "Transport",
    "uld": "ULD",
    "unit": "Unit"
  },
  "errors": {
    "forbidden": "You are not allowed to perform this action.",
    "login": "An unknown error occurred while logging in.",
    "noResponse": "No response received from the server.",
    "unexpected": "An unexpected error occurred."
  },
  "fields": {
    "carrier": "Carrier",
    "city": "City",
    "code": "Code",
    "countryCode": "Country code",
    "displayName": "Display name",
    "driveTime": "Drive time",
    "email": "Email",
    "emailConfirmation": "Email confirmation",
    "iataCode": "IATA code",
    "icaoCode": "ICAO code",
    "name": "Name",
    "olsonZone": "Olson zone",
    "password": "Password",
    "passwordConfirmation": "Password confirmation",
    "startBefore": "Start before",
    "station": "Station",
    "timeZone": "Windows time zone",
    "userName": "User name",
    "currentPassword": "Current password",
    "emailAddress": "Email address",
    "newPassword": "New password",
    "newPasswordConfirmation": "New password confirmation",
    "recoveryCode": "Recovery code",
    "token": "Token",
    "verificationToken": "Verification token",
    "awbPrefix": "AWB prefix",
    "awbSerial": "AWB serial",
    "carrierCode": "Carrier code",
    "driver": "Driver",
    "endCarrierCode": "End carrier code",
    "endLocation": "End location",
    "flightDate": "Flight date",
    "flightNumber": "Flight number",
    "flightType": "Flight type",
    "manifest": "Manifest",
    "pieces": "Pieces",
    "startCarrierCode": "Start carrier code",
    "startLocation": "Start location",
    "uldOwner": "ULD owner",
    "uldPrefix": "ULD prefix",
    "uldSerial": "ULD serial",
    "externalAccount": "{provider} account"
  },
  "flightType": {
    "import": "Import",
    "export": "Export",
    "onBlocks": "On Blocks",
    "offBlocks": "Off Blocks",
    "onOffBlocks": "On/Off Blocks"
  },
  "grid": {
    "noData": "No data to display"
  },
  "labels": {
    "carrier": "Carrier",
    "country": "Country",
    "driveTimeMinutes": "Drive Time (minutes)",
    "exportStartBeforeMinutes": "Export Start Before (minutes)",
    "handleCargo": "Handle Cargo",
    "handleTransport": "Handle Transport",
    "iataCode": "IATA Code",
    "icaoCode": "ICAO Code",
    "lastLoginAt": "Last Login At",
    "locked": "Locked",
    "lockoutEnd": "Lockout End",
    "noLoginYet": "No login yet",
    "notLocked": "Not locked",
    "station": "Station",
    "timeZone": "Time Zone",
    "twoFactor": "2FA",
    "currentPassword": "Current password",
    "email": "Email",
    "name": "Name",
    "roles": "Roles",
    "stations": "Stations",
    "userName": "Username",
    "carrierCodeEnd": "Carrier Code End",
    "carrierCodeStart": "Carrier Code Start",
    "carrierCode": "Carrier Code",
    "carrierEnd": "Carrier End",
    "carrierStart": "Carrier Start",
    "category": "Category",
    "customer": "Customer",
    "date": "Date",
    "destination": "Destination",
    "driver": "Driver",
    "endLocation": "End Location",
    "flight": "Flight",
    "flightDate": "Flight Date",
    "flightNumber": "Flight Number",
    "flightType": "Flight Type",
    "gateChanged": "Gate Changed",
    "gateChanges": "Gate Changes",
    "gateRamp": "Gate/Ramp",
    "hasMail": "Has Mail",
    "mail": "Mail?",
    "manifest": "Manifest",
    "number": "Number",
    "origin": "Origin",
    "shc": "SHC",
    "showChecklist": "Show Checklist",
    "startBefore": "Start Before",
    "startLocation": "Start Location",
    "uld": "ULD",
    "units": "Units",
    "weight": "Weight",
    "fromTo": "From/To",
    "gate": "Gate",
    "status": "Status",
    "externalAccount": "{provider} Account"
  },
  "layout": {
    "accessDeniedHint": "Check your account role(s) and if you have the correct station selected.",
    "accessDeniedText": "Your account does not have permission to access this resource.",
    "accessDeniedTitle": "Access denied",
    "apiDocs": "API",
    "apiDocsTitle": "API documentation",
    "appTitle": "CargoXS Airside Regulations",
    "build": "Build {version}",
    "driver": "Driver",
    "history": "History",
    "logo": "Logo",
    "notFoundText": "The page you are looking for might have been removed, had its name changed or is temporarily unavailable.",
    "notFoundTitle": "Page not found",
    "pageTitle": "{page} - CargoXS Airside",
    "returnHome": "Return to Home page",
    "transports": "Transports"
  },
  "login": {
    "signIn": "Sign in to your account to continue.",
    "login": "Login",
    "logout": "Log out",
    "forgotPassword": "Forgot Password?",
    "enterEmail": "Enter the email address associated with your account.",
    "resetLinkExternal": "A password reset link will only be available if your account is {not} authenticating with an external provider.",
    "not": "not",
    "sendResetLink": "Send Reset Link",
    "resetEmailSent": "We will send you a password reset email if your email address is found.",
    "forgotPasswordFailed": "An unknown error occurred while requesting a password reset.",
    "resetPasswordFailed": "An unknown error occurred while resetting your password.",
    "confirmEmailFailed": "An unknown error occurred while confirming your email address.",
    "emailMissing": "Email address not present.",
    "confirmTokenMissing": "Confirmation token not present.",
    "resetTokenMissing": "Reset token not present.",
    "passwordReset": "Your password has been reset.",
    "updatePassword": "Update password",
    "confirmingEmail": "Confirming your email address.",
    "emailVerified": "Your email address has been successfully verified, you should now be able to {link}.",
    "emailVerifiedLink": "login",
    "newVerificationEmail": "If you require a new verification email, please proceed to {link} and resend.",
    "newVerificationEmailLink": "forgot password",
    "enterCode": "Please enter the code sent to your email or from your authenticator app.",
    "noDevice": "Don't have access to your authenticator device? You can {link}.",
    "noDeviceLink": "log in with a recovery code",
    "recoveryIntro": "Please enter a recovery token you received when registering your authenticator app.",
    "useRecoveryCode": "Use Recovery Code",
    "or": "or",
    "signInWith": "Sign in with {provider}",
    "externalSignInFailed": "Signing in with {provider} failed. Please try again."
  },
  "maintenance": {
    "title": "Maintenance",
    "subtitle": "System administration & master data",
    "maintain": "Maintain {entities}",
    "affectsAllStations": "Affects all stations using Airside Regulations.",
    "administratorsOnly": "Only configurable by Administrators.",
    "carrierCodeFixed": "Existing carrier code cannot be changed.",
    "slaKeyFixed": "Existing SLA carrier & station code cannot be changed.",
    "stationCodeFixed": "Existing station code cannot be changed.",
    "locationInformation": "Location information",
    "timeZoneInformation": "Time Zone information",
    "slas": "SLAs",
    "tabs": {
      "stations": "Stations",
      "carriers": "Carriers",
      "slas": "Carrier SLAs",
      "roles": "Roles",
      "users": "Users",
      "locations": "Locations",
      "categories": "Categories",
      "customers": "Customers"
    },
    "noName": "No name"
  },
  "mfa": {
    "recoveryCodesLeftSelf": "You have {n} recovery code left. | You have {n} recovery codes left.",
    "recoveryCodesLeftUser": "User has {n} recovery code left. | User has {n} recovery codes left.",
    "title": "Multi Factor Authentication",
    "enabled": "MFA Enabled:",
    "appVerified": "MFA App Verified:",
    "cannotEnable": "MFA cannot be enabled: Email address is not confirmed or used with other accounts.",
    "emailCode": "Login will require a verification code received by email.",
    "authenticatorApp": "Authenticator App",
    "recoveryCodes": "Recovery Codes",
    "generateLink": "generate a new set of recovery codes",
    "generateRecoveryCodes": "Generate Recovery Codes",
    "resetKeys": "Reset app MFA keys",
    "removeApp": "Remove app",
    "canGenerate": "You can {link}.",
    "shouldGenerate": "You should {link}.",
    "verifyToken": "Verify Token"
  },
  "notifications": {
    "created": "{entity} '{name}' created successfully.",
    "createdForStation": "{entity} '{name}' for '{station}' created successfully.",
    "updated": "{entity} '{name}' updated successfully.",
    "updatedForStation": "{entity} '{name}' for '{station}' updated successfully.",
    "removed": "{entity} '{name}' has been removed.",
    "removedForStation": "{entity} '{name}' for '{station}' has been removed.",
    "slaCreated": "SLA for '{carrier}' in '{station}' created successfully.",
    "slaUpdated": "SLA for '{carrier}' in '{station}' updated successfully.",
    "slaRemoved": "SLA for '{carrier}' in '{station}' has been removed."
  },
  "pageTitles": {
    "home": "Home",
    "importTransports": "Import Transports",
    "exportTransports": "Export Transports",
    "otherTransports": "Other Transports",
    "transportHistory": "Transport History"
  },
  "transportType": {
    "import": "Import",
    "export": "Export",
    "other": "Other",
    "transfer": "Transfer"
  },
  "transports": {
    "all": "All",
    "title": "Transports - {type}",
    "historyTitle": "Transports - {type} (History)",
    "historyNoUpdates": "History will not receive real-time updates.",
    "flightManifest": "Flight/Manifest",
    "noManifest": "No Manifest",
    "noGate": "No Gate",
    "noDate": "No date",
    "noGateChanges": "No gate changes",
    "noFlight": "No flight available.",
    "noUnits": "No units available, drive not possible.",
    "details": "Details",
    "times": "Times",
    "location": "Location",
    "updateUnitCounts": "Update Unit Counts",
    "cancelTransport": "Cancel Transport",
    "enableTransport": "Enable Transport",
    "confirmCancel": "Are you sure you want to cancel this transport?",
    "confirmCancelTitle": "Confirm Cancel",
    "confirmEnable": "Are you sure you want to enable this transport?",
    "confirmEnableTitle": "Confirm Enable",
    "unitCountsUpdated": "Transport unit counts updated successfully.",
    "statusUpdated": "Transport status successfully updated to '{status}'.",
    "tabs": {
      "info": "Info",
      "flight": "Flight",
      "units": "Units",
      "drives": "Drives",
      "awbs": "AWBs"
    }
  },
  "users": {
    "accountStatus": "Account Status",
    "codesShownOnce": "Only displayed once, make sure you copy them down somewhere safe.",
    "confirmGenerateCodes": "Are you sure you want to generate a new set of recovery codes?",
    "confirmRemoveApp": "Are you sure you want to remove the MFA app registration for the user?",
    "confirmResetKeys": "Are you sure you want to reset the MFA app keys for the user?",
    "createUser": "Create User",
    "details": "User Details {userName}",
    "emailChangeNeedsConfirmation": "Changing the email address will require reconfirmation.",
    "emailState": "Email State",
    "mfaNeedsConfirmedEmail": "Multi Factor Authentication is enabled for this user. Login is not possible without a confirmed email address.",
    "mustGenerate": "You must {link} before the user can log in.",
    "newRecoveryCodes": "New Recovery Code set",
    "noAppYet": "The user has not registered an authenticator app yet.",
    "appNeedsConfirmedEmail": "The user can register an authenticator app when the email address has been confirmed.",
    "removeAppHint": "Remove authenticator app verification from this account.",
    "resetKeysHint": "Reset authentication key for this account and invalidate current app registrations.",
    "rolesAndStations": "Roles & Stations",
    "sendVerificationEmail": "Send verification email",
    "updateEmail": "Update Email",
    "updatePassword": "Update Password",
    "updateProfile": "Update Profile",
    "userNameFromEmail": "Updating an username needs to be done by changing the email address.",
    "profileUpdated": "User profile for '{userName}' updated successfully.",
    "verificationEmailQueued": "Verification email successfully added to the queue.",
    "emailUpdated": "Email for '{userName}' updated successfully.",
    "passwordUpdated": "Password for '{userName}' updated successfully.",
    "recoveryCodesGenerated": "Recovery codes generated successfully.",
    "recoveryCodesFailed": "Unknown error while generating recovery codes.",
    "mfaKeysReset": "MFA app keys reset successfully.",
    "mfaAppRemoved": "MFA app removed successfully.",
    "externalAccount": "{provider} Account",
    "externalAccountHint": "The user signs in with {provider} only and has no password. The account is linked at their first sign-in with {provider}.",
    "externalLinked": "This user signs in with {provider} account {account}. Their password and MFA are handled by {provider}.",
    "externalAssigned": "{provider} account {account} is assigned. It is linked when the user first signs in with {provider}; until then the user signs in as before.",
    "externalNone": "This user signs in with a password. Assign a {provider} account to have them sign in with {provider} instead: their password and MFA are removed at their first sign-in with {provider}.",
    "assignExternal": "Assign Account",
    "unlinkExternal": "Unlink Account",
    "removeExternal": "Remove Account",
    "confirmUnlinkExternal": "Are you sure you want to unlink the {provider} account? The user can no longer sign in with {provider} and receives a mail to set a password.",
    "confirmRemoveExternal": "Are you sure you want to remove the assigned {provider} account?",
    "externalAccountAssigned": "{provider} account assigned.",
    "externalAccountRemoved": "{provider} account removed.",
    "externalPending": "pending",
    "signInMethod": "Sign-in Method"
  },
  "validation": {
    "atLeastOneRole": "At least one role is required.",
    "atLeastOneStation": "At least one station is required.",
    "between": "{field} must be between {min} and {max}.",
    "doesNotMatch": "{field} does not match.",
    "exactLength": "{field} must be {length} characters in length.",
    "invalidFormat": "{field} is not in a valid format.",
    "lengthRange": "{field} must be {min} to {max} characters in length.",
    "maxLength": "{field} must be {max} characters or less.",
    "required": "{field} is required.",
    "specialHandlingCodesFormat": "Special handling codes are 3-letter codes, optionally separated by spaces."
  }
}
